import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a884c60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-userdropdown-tab" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "oxd-userdropdown-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_dropdown_menu = _resolveComponent("oxd-dropdown-menu")!

  return (_openBlock(), _createBlock(_component_oxd_dropdown_menu, { class: "oxd-userdropdown" }, {
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("img", {
          alt: "profile picture",
          class: "oxd-userdropdown-img",
          src: _ctx.user.profImgSrc
        }, null, 8, _hoisted_2),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1),
        _createVNode(_component_oxd_icon, {
          name: "caret-down-fill",
          class: "oxd-userdropdown-icon"
        })
      ])
    ]),
    _: 3
  }))
}